import { Modal, Table, Tabs } from '@arco-design/web-react';
import React from 'react';
import { WebhookForm } from '../../forms/WebhookForm';


export function EditWebhookModal(props) {

  return (
    <Modal
      title="Add Webhook"
      visible={props.visible}
      onCancel={props.onCancel}
      footer={null}
    >
      <WebhookForm
        onUpdateSuccess={props.onSuccess}
        instance={props.instance}
      />
    </Modal>
  )
}